import { render, staticRenderFns } from "./Notif.vue?vue&type=template&id=17ac71d9&scoped=true&"
import script from "./Notif.vue?vue&type=script&lang=ts&"
export * from "./Notif.vue?vue&type=script&lang=ts&"
import style0 from "./Notif.vue?vue&type=style&index=0&id=17ac71d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ac71d9",
  null
  
)

export default component.exports